import { render, staticRenderFns } from "./org-tree.vue?vue&type=template&id=2812ba0e&scoped=true"
import script from "./org-tree.vue?vue&type=script&lang=js"
export * from "./org-tree.vue?vue&type=script&lang=js"
import style0 from "./org-tree.vue?vue&type=style&index=0&id=2812ba0e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2812ba0e",
  null
  
)

export default component.exports